var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5999 16.8641H16.5999M1 16.8641L5.36599 15.9852C5.59776 15.9386 5.81058 15.8246 5.97772 15.6575L15.7514 5.88799C16.22 5.41959 16.2197 4.66035 15.7507 4.19234L13.6803 2.12628C13.2115 1.65847 12.4519 1.65879 11.9835 2.127L2.20876 11.8975C2.04195 12.0642 1.92805 12.2764 1.8813 12.5075L1 16.8641Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2883815adafbfa369ee697f9c094e651.svg";
export { ForwardRef as ReactComponent };